"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M20 11.09v-4.7c0-.83-.52-1.58-1.3-1.87l-6-2.25c-.45-.17-.95-.17-1.4 0L6.78 3.96l12.09 12.09c.72-1.53 1.13-3.22 1.13-4.96m.49 9.4L3.51 3.51a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L4 6.83v4.26c0 4.83 3.13 9.37 7.43 10.75.37.12.77.12 1.14 0 1.49-.48 2.84-1.35 3.97-2.47l2.53 2.53c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41"
}), 'RemoveModeratorRounded');